import React, { useState } from 'react';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '../../../assets/images/visibility_icon.svg';
import { IconButton } from '@mui/material';
import TextField, { TextFieldProps } from '../TextField';

export interface PasswordFieldProps extends TextFieldProps {
    allowPasswordToggle?: boolean;
}

const PasswordField: React.FC<PasswordFieldProps> = ({
    allowPasswordToggle = false,
    ariaLabel,
    ...props
}) => {
    const [isPasswordHidden, setPasswordHidden] = useState(true);

    const togglePassword = () => {
        setPasswordHidden((hidden) => !hidden);
    };

    return (
        <TextField
            {...props}
            type={isPasswordHidden ? 'password' : 'text'}
            endAdornment={
                allowPasswordToggle && (
                    <IconButton
                        style={{ padding: '12px' }}
                        onClick={togglePassword}
                        aria-label={isPasswordHidden ? `Show ${ariaLabel}` : `Hide ${ariaLabel}`}
                    >
                        {isPasswordHidden ? (
                            <img src={VisibilityIcon} alt="visibility" />
                        ) : (
                            <VisibilityOffIcon />
                        )}
                    </IconButton>
                )
            }
        />
    );
};

export default PasswordField;
